import Api from 'utils/api'

export const postCopyInterviewTemplate = ({ title, department, uuid }: {
  title: string
  department?: number | string
  uuid: string
}) =>
  Api.post(['interviewtemplates', uuid, 'copy'], { title, department })

export const postInterviewTemplate = (payload: Record<string, unknown>) =>
  Api.post(['interviewtemplates'], payload)

export const fetchInterviewTemplate = ({ uuid }: { uuid: string }) =>
  Api.get(['interviewtemplates', uuid])

export const fetchInterviewTemplateByUUID = ({ uuid }: { uuid: string }) =>
  Api.get(['interviewtemplateaspdf', uuid])

export const fetchInterviewTemplates = ({
  department,
  limit,
  offset,
  ordering,
  search,
}: {
  department?: number | string
  limit?: number
  offset?: number
  ordering?: string[]
  search?: string
}) =>
  Api.get(['interviewtemplates'], {
    department,
    limit,
    offset,
    ordering,
    search,
  })

export const updateInterviewTemplate = ({ payload, uuid }: {
  payload: Record<string, unknown>
  uuid: string
}) =>
  Api.patch(['interviewtemplates', uuid], payload)

export const deleteInterviewTemplateQuestion = ({ uuid }: { uuid: string }) =>
  Api.delete(['interviewquestions', uuid])

export const postInterviewTemplateQuestion = ({
  description,
  order,
  section,
  title,
}: {
  description?: string
  order: number
  section: string
  title: string
}) => Api.post(['interviewquestions'], { description, order, section, title })

export const updateInterviewTemplateQuestion = ({
  description,
  order,
  title,
  uuid,
}: {
  description?: string
  order: number
  title: string
  uuid: string
}) => Api.patch(['interviewquestions', uuid], { description, order, title })

export const deleteInterviewTemplateSection = ({ uuid }: { uuid: string }) =>
  Api.delete(['interviewsections', uuid])

export const postInterviewTemplateSection = ({
  description,
  interviewTemplate,
  key,
  order,
  scoreable,
  title,
}: {
  description?: string
  interviewTemplate: string
  key?: string
  order: number
  scoreable: boolean
  title: string
}) =>
  Api.post(['interviewsections'], {
    description,
    interview_template: interviewTemplate,
    key,
    order,
    scoreable,
    title,
  })

export const updateInterviewTemplateSection = ({
  key,
  order,
  scoreable,
  title,
  uuid,
}: {
  key?: string
  order: number
  scoreable: boolean
  title: string
  uuid: string
}) => Api.patch(['interviewsections', uuid], { key, order, scoreable, title })
